"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { useEffect, useRef, useState } from "react";
export default function OurStory() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll<HTMLDivElement>({
    once: true,
    threshold: 0.2
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll<HTMLDivElement>({
    once: true,
    threshold: 0.2
  });
  const [scrollY, setScrollY] = useState(0);
  const imageRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleScroll = () => {
      if (imageRef.current) {
        const rect = imageRef.current.getBoundingClientRect();
        const scrollProgress = Math.max(0, Math.min(1, (window.innerHeight - rect.top) / window.innerHeight));
        setScrollY(scrollProgress * 30);
      }
    };
    const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (!prefersReducedMotion) {
      window.addEventListener("scroll", handleScroll, {
        passive: true
      });
      handleScroll();
    }
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  const prefersReducedMotion = typeof window !== "undefined" && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  return <section className="relative w-full overflow-hidden bg-background py-16 md:py-24">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 md:gap-12 lg:gap-16">
          {}
          <div ref={leftRef} className={`flex flex-col justify-center space-y-6 ${leftVisible && !prefersReducedMotion ? "animate-fade-in-up" : leftVisible ? "opacity-100" : "opacity-0"}`}>
            <div className="space-y-4">
              <h2 className="font-display text-4xl font-bold leading-tight text-foreground md:text-5xl lg:text-6xl">
                Our Story
              </h2>
              <div className="h-1 w-16 bg-primary"></div>
            </div>

            <div className="space-y-4 text-foreground">
              <p className="text-lg leading-relaxed">
                K&M Mechanical Services was founded with a singular vision: to deliver impeccable HVAC craftsmanship
                and unparalleled customer satisfaction to the Pittsburgh community.
              </p>
              <p className="leading-relaxed">
                For over a decade, our experienced technicians have been trusted by homeowners and businesses across
                Pennsylvania to design, install, maintain, and repair heating, ventilation, and air conditioning
                systems with precision and care.
              </p>
              <p className="leading-relaxed">
                We prioritize energy efficiency, indoor air quality, and reliable performance in every project. By
                combining advanced diagnostics with transparent communication, we build lasting relationships and
                ensure year-round comfort for our clients.
              </p>
              <p className="leading-relaxed">
                Our commitment to precision workmanship and responsive service positions us as a trusted partner for
                Pennsylvania homeowners and businesses seeking dependable climate control solutions.
              </p>
            </div>

            <div className="pt-4">
              <div className="inline-flex items-center gap-2 text-primary font-semibold">
                <span>Serving Pittsburgh since 2010</span>
              </div>
            </div>
          </div>

          {}
          <div ref={rightRef} className={`relative ${rightVisible && !prefersReducedMotion ? "animate-fade-in-up-delay-100" : rightVisible ? "opacity-100" : "opacity-0"}`}>
            <div ref={imageRef} className="group relative h-full min-h-[400px] overflow-hidden rounded-lg bg-dark-background md:min-h-[600px]">
              {}
              <div className="absolute inset-0 z-10 bg-dark-background/60 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] group-hover:bg-dark-background/40"></div>

              {}
              <div className="absolute inset-0 bg-cover bg-center transition-transform duration-[var(--duration-medium)] ease-[var(--ease-smooth)]" style={{
              backgroundImage: "url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1516646/img/kmm_team_on_site.png)",
              transform: prefersReducedMotion ? "none" : `translateY(${scrollY}px)`
            }}></div>

              {}
              <div className="pointer-events-none absolute inset-0 z-20 opacity-0 transition-opacity duration-[var(--duration-medium)] ease-[var(--ease-smooth)] group-hover:opacity-100">
                <div className="absolute inset-0 bg-gradient-to-br from-transparent via-primary/10 to-transparent"></div>
              </div>

              {}
              <div className="absolute bottom-0 left-0 right-0 z-30 p-6">
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}